export default () => value => value.length === 1 ? undefined : 'ra.validation.oneCharacter'
